import React, { Component } from 'react';
import './Perfil.css';
import services from '../../services/index';
import FormCliente from '../../components/FormCliente/FormCliente';

import Header from '../../components/header/Header';
import Loading from '../../components/loading/Loading';
import { Redirect } from 'react-router-dom';

export default class Perfil extends Component {

  state = {
    logado: false,
    redirect: false,
    loadingPage: false,
    change: false
  }


  async componentDidMount() {
    this.setState({ loadingPage: true })
    let logado = await services.isLogado();
    if (!logado) {
      this.setState({ redirect: true, loadingPage: false });
      return
    }
    this.setState({ loadingPage: false, logado: true })
  }

  state = {
    change: false
  }


  handeOtherAdress = () => {
    this.setState({ change: !this.state.change });
  }



  handleChange = () => {
    this.setState({ change: !this.state.change });
  }





  render() {
    if (this.state.redirect) {
      return <Redirect to={{ pathname: '/', state: { from: '/' } }} />
    }

    if (this.state.loadingPage) {
      return <Loading />
    } else {


      return (
        <div>
          <Header logado={this.state.logado} change={this.state.change} />
          <FormCliente handeOtherAdress={this.handeOtherAdress} handleChange={this.handleChange} />
        </div>
      )
    }
  }
}
